import { useEffect, useRef } from 'react';
import { UserButton, useUser } from '@clerk/clerk-react';
import { useReducer } from 'react';
import { Helmet } from 'react-helmet';
import Reducer from '../../../services/Reducer';
import { Avatar } from '@mui/material';
import { CallWithAuth } from '../../../actions/apiAction';
import { CHAT_URL, CUSTOMER_PORTAL_URL } from '../../../utils/apiUrl';
import Cookie from '../../../utils/Cookie';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import toast from 'react-hot-toast';
const initState = {
    userList: '',
    loading: false,
};
const Settings = () => {
    const { user } = useUser();
    const [state, dispatch] = useReducer(Reducer, initState);
    const navigator = useNavigate();
    const profileTileRef = useRef(null);

    const handleProfileTileClick = (e) => {
        // If user clicked the Clerk UserButton (avatar), let it handle the click
        if (e.target.closest('.cl-userButtonTrigger') || e.target.closest('[data-clerk-component]')) {
            return;
        }
        // User clicked elsewhere on the tile — open account menu by triggering the UserButton
        const trigger = profileTileRef.current?.querySelector('.cl-userButtonTrigger') || profileTileRef.current?.querySelector('[data-clerk-component] button');
        trigger?.click();
    };

    const handleChatClick = (item) => {
        Cookie.setCookie('activeChatId', item?._id, 1);
        navigator('/user/chat?id=' + item?.creator_id, { state: { user: item } })
    }

    const getUserList = async () => {
        dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });

        let responce = await CallWithAuth("GET", CHAT_URL);
        if (responce.data) {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: responce?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: [] } });

        }
        dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    };
    useEffect(() => {
        getUserList();
    }, []);
    return (
        <>
            <Helmet>
                <title>Settings | TLK</title>
            </Helmet>
            {/* start: Account Settings page */}
            <div className="min-h-screen gradient-bg-1 p-6">
                <div className="flex items-center gap-4 mb-8">
                    <button className="text-foreground/70 hover:text-foreground transition-colors"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#af0056"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-xl font-bold text-foreground">Account Settings</h1>
                </div>
                <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>
                    <div
                        ref={profileTileRef}
                        role="button"
                        tabIndex={0}
                        onClick={handleProfileTileClick}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleProfileTileClick(e); } }}
                        className="bg-card rounded-2xl p-6 border border-border shadow-md mb-6 cursor-pointer hover:border-primary/30 hover:shadow-lg transition-all select-none"
                        style={{ opacity: 1, transform: "none" }}
                        aria-label="Open account menu"
                    >
                        <div className="flex items-center gap-4">
                            <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center data-clerk-component">
                                {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-user w-8 h-8 text-primary"
                                >
                                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                                    <circle cx={12} cy={7} r={4} />
                                </svg> */}
                                <UserButton />
                            </div>
                            <div className="flex-1">
                                <h2 className="font-semibold text-foreground">{user?.fullName}</h2>
                                <p className="text-sm text-muted-foreground">{user.emailAddresses[0].emailAddress}</p>

                            </div>
                        </div>
                    </div>
                    <div className="space-y-2">
                        <button
                            className="w-full flex items-center gap-4 p-4 rounded-xl transition-all bg-gradient-to-r from-primary/20 to-accent/20 border-2 border-primary/30"
                            style={{ opacity: 1, transform: "none" }}
                            onClick={() => navigator("/user/manage-account")}
                        >
                            <div className="p-2 rounded-full bg-primary/20">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-crown w-5 h-5 text-primary"
                                >
                                    <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z" />
                                    <path d="M5 21h14" />
                                </svg>
                            </div>
                            <div className="flex-1 text-left">
                                <p className="font-medium text-foreground">
                                    Subscription &amp; Billing
                                </p>
                                <p className="text-xs text-muted-foreground">
                                    Premium Plan • Payments &amp; receipts
                                </p>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-chevron-right w-5 h-5 text-muted-foreground"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                        <button
                            className="w-full flex items-center gap-4 p-4 rounded-xl transition-all bg-card border border-border hover:border-primary/30"
                            style={{ opacity: 1, transform: "none" }}
                            onClick={() => navigator('/user/notification')}
                        >
                            <div className="p-2 rounded-full bg-primary/20">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-bell w-5 h-5 text-foreground/70"
                                >
                                    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                                    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                                </svg>
                            </div>
                            <div className="flex-1 text-left">
                                <p className="font-medium text-foreground">Notifications</p>
                                <p className="text-xs text-muted-foreground">
                                    Push &amp; email preferences
                                </p>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-chevron-right w-5 h-5 text-muted-foreground"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                        <button
                            className="w-full flex items-center gap-4 p-4 rounded-xl transition-all bg-card border border-border hover:border-primary/30"
                            style={{ opacity: 1, transform: "none" }}
                            onClick={() => navigator('/user/data-protect')}
                        >
                            <div className="p-2 rounded-full bg-primary/20">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-shield w-5 h-5 text-foreground/70"
                                >
                                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                </svg>
                            </div>
                            <div className="flex-1 text-left">
                                <p className="font-medium text-foreground">Privacy &amp; Data</p>
                                <p className="text-xs text-muted-foreground">Manage your data</p>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-chevron-right w-5 h-5 text-muted-foreground"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                        <button
                            className="w-full flex items-center gap-4 p-4 rounded-xl transition-all bg-card border border-border hover:border-primary/30"
                            style={{ opacity: 1, transform: "none" }}
                            onClick={() => navigator('/user/help')}
                        >
                            <div className="p-2 rounded-full bg-primary/20">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-circle-help w-5 h-5 text-foreground/70"
                                >
                                    <circle cx={12} cy={12} r={10} />
                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                    <path d="M12 17h.01" />
                                </svg>
                            </div>
                            <div className="flex-1 text-left">
                                <p className="font-medium text-foreground">Help &amp; Support</p>
                                <p className="text-xs text-muted-foreground">FAQs &amp; contact us</p>
                            </div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-chevron-right w-5 h-5 text-muted-foreground"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                    </div>
                    {/* <button
                        className="w-full mt-6 py-3 text-sm text-muted-foreground hover:text-destructive transition-colors"
                        style={{ opacity: 1 }}
                    >
                        Cancel Subscription
                    </button> */}
                    <div className="flex justify-center gap-4 mt-4">
                        <button className="text-xs text-muted-foreground underline hover:text-foreground/80"
                            onClick={() => navigator('/user/terms')}
                        >
                            Terms
                        </button>
                        <button className="text-xs text-muted-foreground underline hover:text-foreground/80"
                            onClick={() => navigator('/user/privacy')}
                        >
                            Privacy
                        </button>
                    </div>
                </div>
            </div>

            {/* end: Account Settings page */}
        </>
    );
}

export default Settings;
